module.exports = __webpack_public_path__ + "static/media/automation.b8902aeb.svg";